/* unplugin-vue-components disabled */import script from "./UploadVideo.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadVideo.vue?vue&type=script&setup=true&lang=js"

import "./UploadVideo.vue?vue&type=style&index=0&id=707dc5c4&lang=scss"

const __exports__ = script;

export default __exports__